import CallIcon from '@material-ui/icons/Call';
import PlayCircleOutline from '@material-ui/icons/PlayCircleOutline';
import AddBox from '@material-ui/icons/AddBox';
import { colors } from '~/layout';
import * as lib from '~/dependencies';

export const Container = lib.styled.div`
  background-color: ${colors.white};
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow: hidden;

  .addContact {
    position: absolute;
    bottom: 20px;
    right: 20px;
    cursor: pointer;
  }

  .rowContacts {
    /* position: relative!important; */
    /* top: 0px!important; */
    /* height: auto!important; */
    min-height: 52px;
    margin-bottom: 7px;
  }
  .list--header {
    /* position: relative!important; */
    /* top: 0px!important; */

    .line-header {
      /* position: relative!important; */
      /* top: 0px!important; */
    }
  }
`;

export const EmptyStateComponent = lib.styled.div`
  display: flex;
  height: inherit;
  flex: 1;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  opacity: 0.5;
  color: ${colors.darkGray02}!important;
  & > svg: {
    fontSize: 4.0rem;
  };
  & > p: {
    color: ${colors.darkGray02}!important;
  };
`;

export const LoadingContainer = lib.styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

export const Block = lib.styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow: hidden;
`;

export const NoContent = lib.styled.div`
  flex: 1;
  align-items: center;
  justify-content: center;
  display: flex;

  svg {
    margin-right: 10px;
  }
`;

export const BoxActions = lib.styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CallIconComponent = lib.styled(CallIcon)`
  color: ${props => (props.disabled ? colors.lightGray02 : colors.greenNormal)};
`;
export const PlayCircleOutlineComponent = lib.styled(PlayCircleOutline)`
  color: ${colors.greenNormal};
`;
export const AddBoxIconComponent = lib.styled(AddBox)`
  color: ${props => (props.disabled ? colors.lightGray02 : colors.greenNormal)};
`;

export const BoxBtn = lib.styled.div`
  width: 26px;
  height: 26px;
  background-color: ${colors.white};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  cursor: pointer;

  .icon {
    div {
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`;
